import { BookingInformation } from '../../booking/models/booking-information.model';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IKeyValueInterface } from './../../shared/config';
import { BookingService } from '../../booking/models/booking.service';
import {
  WeGoConfig,
  IAPIResponse,
  DataListModel,
  ApplicationRouteURL,
  BookingStatus
} from '../../shared/config';
import { Location } from '@angular/common';
import { SearchBookingModel } from '../../booking/models/search-booking.model';

const moment = require('moment');

@Component({
  selector: 'wego-driver-bookinginformation',
  template: require('../views/driver-bookinginformation.component.html'),
  styles: [
    `
      span.label.label-default {
        font-size: 13px;
        line-height: 35px;
        background-color: #eeeeee;
        color: #2ba2aa;
        margin-right: 5px;
      }

      span.label.label-default.text-success {
        color: #3c763d;
      }

      span.label.label-default.text-danger {
        color: #a94442;
      }

      .invoice_longcols {
        padding-right: 0px;
      }
    `
  ],
  providers: [BookingService]
})
export class DriverBookingInformationComponent implements OnInit {
  apiErrorMsg: string;
  sub: any;
  readMore: IKeyValueInterface[];
  isLoading: boolean;
  message: string;
  model: BookingInformation;
  urlBooking: string;
  urlDefaultPage: string;
  bookingHashId: string;
  urlBookingOverView: string;
  popupTitle: string;

  @ViewChild('successPopup') public successPopup: any;

  popupMsg: any;
  isSuccess: boolean;

  errorMessage: string;
  popupDescription: string;

  retrieveVehicleInfo: boolean = false;
  
  constructor(
    private authService: AuthService,
    private bookingService: BookingService,
    private router: Router,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private locationService: Location
  ) {}

  ngOnInit() {
    this.model = new BookingInformation();
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.urlBookingOverView = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_OVERVIEW
    );
    this.sub = this.activeRoute.params.subscribe(params => {
      this.bookingHashId = params['bookingHashId'] || '';
      if (this.bookingHashId != '') {
        this.GetBookingInformation();
      }
    });
  }

  private GetBookingInformation() {
    this.isLoading = true;
    this.bookingService
      .GetBookingInformationByHashId(this.bookingHashId, 'page1')
      .subscribe(
        res => {
          if (res.data) {
            this.model = res.data;
            this.isLoading = false;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }

  public GroupByCategory(vehicleAttributeList: any) {
    if (vehicleAttributeList) {
      let prop = 'vehicleAttributeCategoryName';
      return vehicleAttributeList.reduce(function(groups: any, item: any) {
        let val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        groups[val] = groups[val].sort((obj1: any, obj2: any) => {
          if (obj1.attributeName > obj2.attributeName) {
            return 1;
          }

          if (obj1.attributeName < obj2.attributeName) {
            return -1;
          }
          return 0;
        });
        return groups;
      }, {});
    } else {
      return {};
    }
  }

  public ConfirmSuccessPopup(): void {
    this.router.navigate([this.urlBookingOverView]);
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/components/driver-bookinginformation.component.ts